<template>
  <div>
    <Head>
      <Title>{{ $t('pages.table.meta.title', useTeamParams()) }}</Title>
      <Meta name="description" :content="$t('pages.table.meta.description', useTeamParams())" />
      <!-- <Link rel="canonical" :href="useAbsolutePath()" /> -->
    </Head>
    <div class="space-y-4">
      <TeamNavTable />
      <div class="bg-white border rounded-md p-2">
        <PartialsTable :rows="data?.rows" :side="side" />
      </div>
      <TeamSeoText type="table" class="mt-8" />
    </div>
  </div>
</template>

<script setup>
definePageMeta({
  layout: 'team'
})

const route = useRoute()
const team = useTeamStore()

const side = computed(() => route.query?.side || undefined)

const { data } = await useFetch(`/api/v1/teams/${team.slug}/table`, {
  key: `team-table-${team.slug}`,
  baseURL: useEnv('apiBase'),
})
</script>